import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * This Component creates Page Header for every page
 */
const PageHeader = props => {
    const {
        additionalElement,
        additionalElementClassName,
        additionalElementStyle,
        auxClassName,
        auxText,
        headerClassName,
        text,
        textReplacements = {},
        auxTextReplacements = {},
        dataTestId,
        id
    } = props;

    return (
        <div className="page-header">
            <div className="grid-row">
                <div className="mobile:grid-col-12 tablet:grid-col-fill">
                    <h3
                        className={`${headerClassName}`}
                        data-testid={dataTestId ?? text}
                        id={id}
                    >
                        <FormattedMessage
                            id={text}
                            values={textReplacements}
                        />
                            &nbsp;
                        {
                            auxText && (
                                <span className={`${auxClassName}`}>
                                    <FormattedMessage
                                        id={auxText}
                                        values={auxTextReplacements}
                                    />
                                </span>
                            )
                        }
                    </h3>
                </div>

                {
                    additionalElement && (
                        <div className="mobile:grid-col-12 tablet:grid-col-auto">
                            <span
                                className={additionalElementClassName}
                                style={additionalElementStyle}
                            >
                                { additionalElement }
                            </span>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default PageHeader;
